import { OrdersPageType } from '@/components/Orders/Dashboard/OrdersPresentation';
import styles from './OrdersNavbar.module.scss';
import Navbar from '../Navbar/Navbar';
import useOnlineStatus from '@/hooks/useOnlineStatus';
import { isMobileResolution, isProductionEnv, getEnvLabel, isIOSWebView } from '@/utils';
import NavigationSelect from '@/common/NavigationSelect';
import { DropdownOptions, getNavigationSchema } from '@/routes/navigation';
import SelectOval from '@/common/SelectOval/SelectOval';
import SettingsCogIcon from '@/assets/icons/settings-cog.svg?react';
import AddPlus from '@/assets/icons/add_plus.svg?react';
import { useEffect, useState } from 'react';
import { getUser } from '@/library/UserSessionHelper';
import { ordersReportName } from '@/constants';

export const isReportVisible = (reportLabel: string, reportSettings: Record<string, boolean>): boolean => {
  switch (reportLabel) {
    case ordersReportName.clubOrderSystemReport:
      return reportSettings.clubOrderSystemReport;
    case ordersReportName.compOrderSystemReport:
      return reportSettings.compOrderSystemReport;
    case ordersReportName.putterOrderSystemReport:
      return reportSettings.putterOrderSystemReport;
    default:
      return false; // unknown reports are hidden
  }
};

interface IProps {
  currentPage: OrdersPageType;
  // eslint-disable-next-line no-unused-vars
  setCurrentPage: (value: OrdersPageType) => void;
  onOpenSettings: () => void;
  onNewOrder: () => void;
}
export default function OrdersNavbar({ currentPage, setCurrentPage, onOpenSettings, onNewOrder }: IProps) {
  const isOnline = useOnlineStatus();
  const schema = getNavigationSchema('/orders');
  const dropdownOptions = schema?.dropdownOptions || [];
  const [loading, setLoading] = useState(true);
  const [reports, setReports] = useState<DropdownOptions>([]);
  const showReportsDropdown = !loading && Boolean(reports.length) && !isIOSWebView && !isMobileResolution;

  const pages = [
    { label: 'Clubs', value: OrdersPageType.Clubs },
    { label: 'Components', value: OrdersPageType.Components },
    { label: 'Putters', value: OrdersPageType.Putters },
  ];

  useEffect(() => {
    const fetchReportSettings = async () => {
      const user = await getUser();
      const tourReportSettings = user?.ordersReportSettings as Record<string, boolean>;

      if (!tourReportSettings) {
        setLoading(false);
        return;
      }

      const filteredOptions = dropdownOptions.filter((option) => isReportVisible(option.label, tourReportSettings));
      setReports(filteredOptions);
      setLoading(false);
    };
    fetchReportSettings();
  }, []);

  return (
    <Navbar title="Orders">
      <div className={styles.navbarContent}>
        <div>
          <SelectOval
            options={pages}
            value={currentPage}
            setValue={(value) => {
              const page = pages.find((option) => option.value === value);
              if (page) setCurrentPage(page.value);
            }}
          />
        </div>
        <div className={styles.rightNavbar}>
          <div>{isOnline && showReportsDropdown && <NavigationSelect placeholder="Reports" options={reports} className={styles.select} />}</div>
          <button type="button" className={styles.settingsButton} onClick={onOpenSettings}>
            <SettingsCogIcon className={styles.settingsCog} />
            <span className={styles.label}>Settings</span>
          </button>
          <button type="button" className={styles.settingsButton} onClick={onNewOrder}>
            <div>
              <AddPlus className={styles.newOrderButton} />
            </div>
            <span className={styles.newOrderLabel}>New Order</span>
          </button>
        </div>
        {/* dev/uat status label */}
        {!isProductionEnv && (
          <div className={`${styles.envLabel} ${isOnline ? styles.envLabelOnline : styles.envLabelOffline}`}>{`${getEnvLabel()?.toUpperCase()} ${isMobileResolution ? '' : 'ENV'}`}</div>
        )}
      </div>
    </Navbar>
  );
}
